"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    dateFormatData: _propTypes.default.shape({
      date: _propTypes.default.shape({
        noYear: _propTypes.default.string,
        fullWithDay: _propTypes.default.string,
        noDay: _propTypes.default.string,
        abbreviate: _propTypes.default.string,
        general: _propTypes.default.string
      }),
      shortDaysTranslation: _propTypes.default.object,
      shortMonthTranslation: _propTypes.default.object,
      fullDaysTranslation: _propTypes.default.object,
      fullMonthTranslation: _propTypes.default.object,
      letterDaysTranslation: _propTypes.default.object
    }),
    disableOneway: _propTypes.default.bool,
    labelDepart: _propTypes.default.string,
    labelReturn: _propTypes.default.string,
    viewType: _propTypes.default.string,
    maxDays: _propTypes.default.number,
    calendarOutputdata: _propTypes.default.func,
    theme: _propTypes.default.string,
    confirmLabel: _propTypes.default.string,
    resetLabel: _propTypes.default.string,
    prefillDefaultDepart: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
    prefillDefaultReturn: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
    flightDepart: _propTypes.default.instanceOf(Date),
    flightReturn: _propTypes.default.instanceOf(Date),
    openCalendarModal: _propTypes.default.bool,
    callbackOpenCalendarModal: _propTypes.default.func,
    customDateLabels: _propTypes.default.object,
    currencyFormatData: _propTypes.default.object,
    calendarDirection: _propTypes.default.oneOf(Object.values(_constant2.CALENDAR_OPEN_CALENDAR_DIRECTION)),
    lowestFareLabel: _propTypes.default.string,
    noFareLabel: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    enableLFC: _propTypes.default.bool,
    environment: _propTypes.default.oneOf(Object.keys(_constant2.DEFAULT_LFC_ENDPOINT)),
    lfcDepartEndpoint: _propTypes.default.string,
    lfcReturnEndpoint: _propTypes.default.string,
    lfcConfig: _propTypes.default.shape({
      member: _propTypes.default.string,
      role: _propTypes.default.string,
      currency: _propTypes.default.string,
      baseCurrency: _propTypes.default.string,
      origin: _propTypes.default.string,
      destination: _propTypes.default.string,
      departDate: _propTypes.default.string,
      returnDate: _propTypes.default.string,
      monthsToDisplay: _propTypes.default.number
    }),
    prefillLfcOneWayPrice: _propTypes.default.object,
    prefillLfcReturnPrice: _propTypes.default.object,
    snapLfcPrices: _propTypes.default.object,
    preFillTripType: _propTypes.default.string,
    maxRangeDays: _propTypes.default.number,
    isOnlyApplyForHotel: _propTypes.default.bool,
    isSnapCalendar: _propTypes.default.bool,
    isPartialHotelCalendar: _propTypes.default.bool,
    minNights: _propTypes.default.number,
    enableAvailableDateCalendarFlag: _propTypes.default.bool,
    headerInputContainerPadding: _propTypes.default.string,
    emitOutputOnlyOnConfirm: _propTypes.default.bool,
    resetToPrefilledDates: _propTypes.default.bool,
    disableDepart: _propTypes.default.bool,
    disableReturn: _propTypes.default.bool,
    addCalenderIconForMobile: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    maxDays: 365,
    calendarDirection: _constant2.CALENDAR_OPEN_CALENDAR_DIRECTION.LEFT,
    dateFormatData: _constant2.DEFAULT_DATEFORMATDATA,
    currencyFormatData: _constant2.DEFAULT_CURRENCYFORMATDATE,
    confirmLabel: _constant2.DEFAULT_CONFIRM_LABEL,
    resetLabel: _constant2.DEFAULT_RESET_LABEL,
    openCalendarModal: false,
    preFillTripType: _constant2.TRIP_RETURN,
    enableLFC: false,
    environment: _constant2.DEFAULT_ENVIRONMENT,
    lfcConfig: {},
    isOnlyApplyForHotel: false,
    isSnapCalendar: false,
    snapLfcPrices: null,
    isPartialHotelCalendar: false,
    enableAvailableDateCalendarFlag: false,
    flightDepart: undefined,
    flightReturn: undefined,
    headerInputContainerPadding: null,
    emitOutputOnlyOnConfirm: false,
    resetToPrefilledDates: false,
    disableDepart: false,
    disableReturn: false,
    addCalenderIconForMobile: false
  }
};
exports.default = _default;